module.exports = __webpack_public_path__ + "static/media/location.e6b1bc79.svg";